<app-playground [backgrounds]="['https://www.poettinger.at/img/myPoettinger/Hilfe/Kontakt_2000x1000px.webp']"
  title="{{'contact' | translate}}">
</app-playground>

<div class="container space mt-5">

  <div class="pb-4">
    <strong class="pb-2">{{ 'contactNeedHelp' | translate }}</strong>
    <p class="pb2 mb-0">{{ 'contactWriteMessage' | translate }}</p>
    <p>{{ 'contactInfo1997' | translate }}</p>
  </div>

  <div class="row">
    <div class="col">
      <form class="needs-validation">
        <div class="hp-field" aria-hidden="true">
          <label for="inputWebsite">Website</label>
          <input id="inputWebsite" type="text" name="website" tabindex="-1" autocomplete="off"
            [(ngModel)]="ticket.website" [ngModelOptions]="{standalone: true}">
        </div>
        <div class="form-row">
          <div class="form-group col">
            <label for="inputFirstName" class="form-label">{{'Firstname' | translate}}*</label>
            <input id="inputFirstName" class="form-control" [(ngModel)]="ticket.firstName" required
              [ngModelOptions]="{standalone: true}">
              <div class="invalid-feedback">
                {{ 'InvalidFirstnameText' | translate }}
              </div>
            </div>
            <div class="form-group col">
              <label for="inputLastName" class="form-label">{{'Lastname' | translate}}*</label>
              <input id="inputLastName" class="form-control" [(ngModel)]="ticket.lastName" required
                [ngModelOptions]="{standalone: true}">
                <div class="invalid-feedback">
                  {{ 'InvalidLastnameText' | translate }}
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col">
                <label for="inputEmail" class="form-label">{{'E-mail' | translate}}*</label>
                <input id="inputEmail" class="form-control" type="email" [(ngModel)]="ticket.email" required
                  [ngModelOptions]="{standalone: true}">
                  <div class="invalid-feedback">
                    {{ 'InvalidE-MailText' | translate }}
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col">
                  <label for="selectLanguage" class="form-label">{{'Topic' | translate}}*</label>
                  <select id="selectLanguage" class="form-control" [(ngModel)]="ticket.topic" required
                    [ngModelOptions]="{standalone: true}">
                    @for (topic of topics; track topic) {
                      <option [value]="topic">{{ 'topics.'+topic | translate}}
                      </option>
                    }
                  </select>
                  <div class="invalid-feedback">
                    {{ 'InvalidTopicText' | translate }}
                  </div>
                </div>

                @if (ticket.topic.includes('MP-')) {
                  <div class="form-group col">
                    <label for="inputChassisNr" class="form-label">{{'Machinenumber' | translate}}*</label>
                    <input id="inputChassisNr" class="form-control" [(ngModel)]="ticket.machineNumber" required
                      [ngModelOptions]="{standalone: true}">
                      <div class="invalid-feedback">
                        {{ 'InvalidMachineNumberText' | translate }}
                      </div>
                    </div>
                  }
                </div>
                <div class="form-row">
                  <div class="form-group col">
                    <label for="inputSubject" class="form-label">{{'Subject' | translate}}*</label>
                    <input id="inputSubject" class="form-control" [(ngModel)]="ticket.subject" required
                      [ngModelOptions]="{standalone: true}">
                      <div class="invalid-feedback">
                        {{ 'InvalidSubjectText' | translate }}
                      </div>
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col">
                      <label for="inputMessage" class="form-label">{{'Message' | translate}}*</label>
                      <textarea rows="10" id="inputMessage" class="form-control" [(ngModel)]="ticket.message" required
                      [ngModelOptions]="{standalone: true}" (ngModelChange)="setMessageValidity()"></textarea>
                      <div class="invalid-feedback">
                        {{ 'InvalidMessageText' | translate }}
                      </div>
                    </div>
                  </div>
                  <div #turnstileContainer [class.turnstile-interactive]="captchaInteractive()"></div>
                  <div class="form-row">
                    <div class="form-group col">
                      <button class="button btn-poettinger" type="submit" [disabled]="!captchaToken()" (click)="onSubmitTicket()">
                      {{'sendEmail' | translate}}</button>
                    </div>
                  </div>
                </form>
              </div>

              <div class="d-none d-md-block col">
                <img src="https://www.poettinger.at/img/myPoettinger/Hilfe/Maschinenschild_550x800px.jpg" alt="Support">
              </div>
            </div>
          </div>